import React, {memo, useEffect, useLayoutEffect, useRef, useState} from "react";
import "./MindMap.scss";
import { Input, Modal, Image as AntdImage } from "antd";
import { NonDeletedExcalidrawElement } from "../../element/types";
import { AppState } from "../../types";
import {emitter, mindMapCache} from "../../element/mindMap";
import {recvMessage, unSubscribe} from "../../../../../src/common/event";
import {
  EVENT_MINDMAP_ADD_CARD,
  EVENT_MINDMAP_ADD_PDF, EVENT_MINDMAP_DELETE_CARD,
  EVENT_MINDMAP_LINK_INFO, getMindmapRootTextColor, getMindmapSecondTextColor,
  KEY_FILE_DIR
} from "../../../../../src/Const";
import global from '../../../../../src/global.js'
import DialogChooseImage from "../../../../../src/views/Draw/DialogChooseImage";
import DialogChooseCardPdf from "../../../../../src/views/Draw/DialogChooseCardPdf";
import {
  createCopyLink,
  createNoteElementByNote,
  generateUUID2, getLocalFilePath,
  getPdfImageThumb,
  isDarkMode, isStringNullOrEmpty,
  noteToPng
} from "../../../../../src/utils";
import {ipcInvoke} from "../../../../../src/common/ipc";
import {updateMindmapLinkIcon} from "../../../../../src/Utility0";
// @ts-ignore
import { getTextFromHtml } from "simple-mind-map/src/utils";
import {PROJECT_ID} from "../../../../../src/views/Draw/DrawIndex";
import {mutateElement} from "../../element/mutateElement";
import {getCardById} from "../../../../../model";
import { t } from "i18next";

interface MindMapProps {
  elements: readonly NonDeletedExcalidrawElement[];
  appState: Readonly<AppState>;
  modal: {
    visible: boolean;
    type: "link" | "image";
    delta?: any;
  };
}

const MindMap = memo(({ elements, appState,modal }: MindMapProps) => {
  const [selectedMindmap, setSelectedMindmap] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState({
    visible: false,
    href: "",
  });
  const [link, setlink] = useState("");
  const [linkLabel, setlinkLabel] = useState("");
  const [image, setImage] = useState("");
  const [imageLabel, setImageLabel] = useState("");
  const [selectedNode, setSelectedNode] = useState<any>(null);
  const dialogChooseImageRef = useRef(null);
  const dialogChooseCardPdfRef = useRef(null);

  const [isShowDialogChooseCardPdf,setIsShowDialogChooseCardPdf] = useState(false);

  const handleOk = (type:string,image:string,jsonObj:any=null,mode:'insertion'|'icon') => {

    if (type === "link") {
      if (!link || !linkLabel) {
        return;
      }
      selectedNode.setHyperlink(link, linkLabel);

      const { delta } = modal;
      if (delta) {
        const currentText = getTextFromHtml(selectedNode.getData().text);
        const ops = delta.ops;
        const retainOpsItem = ops.find((item: any) => item.retain);

        const isSetlinkLabel = currentText.length === 1 && currentText === "@";
        const text = isSetlinkLabel
            ? linkLabel
            : currentText
                .split("")
                .filter((item: any, index: number) => {
                  if (retainOpsItem) {
                    if (index === retainOpsItem.retain) {
                      return false;
                    }
                  }
                  return true;
                })
                .join("");

        selectedNode.setText(text);
      }
      handleCancel();
    } else {
      if (mode == 'icon'){
        let szDeeplink = createCopyLink('library',jsonObj?.id,'card',null,null,null,false);
        selectedNode.setAttachment({
          url: szDeeplink,
          title: imageLabel,
        });
        selectedNode._customInfo = {
          href: szDeeplink,
          title: imageLabel,
        };

        //标题----.
        const currentText = getTextFromHtml(selectedNode.getData().text);
        if (!currentText){
          selectedNode.setText(`<span style="font-size: 16px; font-family: OpenSans; color: ${isDarkMode()?'rgb(204, 204, 204)':'rgb(86, 86, 86)'};">${jsonObj?.name || ''}</span>`);
          const newData = selectedNode.mindMap.getData();

          //只能这样更新。这个奇葩的东西...
          for (let i=0;i<5;i++){
            setTimeout(()=>{
              // mutateElement(selectedNode.mindMap.element,{data:newData});
              window.forceUpdatMindmapData(selectedNode.mindMap.element.id,newData);
            },i*100)
          }
        }

        updateMindmapLinkIcon();
      }else{
        new Promise<{ width: number; height: number }>((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            const size = { width: img.width, height: img.height };

            //clear input
            // @ts-ignore
            let fileInput = document.getElementById('fileInput');
            if (fileInput){
              fileInput.value = '';
            }
            img.remove();
            resolve(size);
          };
          img.onerror = (error) => {
            reject(error);
          };
          img.src = image;
          if (jsonObj != null){
            delete jsonObj.content;
            // img.dataset.jsonStr = JSON.stringify(jsonObj);
          }
        }).then((size) => {
          //保存额外的数据........
          selectedNode.setData({
            ...selectedNode.getData(),
            extra:{
              ...jsonObj
            }
          })

          let nSize = 200;
          if (jsonObj?.type == 'pdf'){
            nSize = 100;
          }

          const scale = nSize / size.width;
          selectedNode.setImage({
            url: image,
            title: imageLabel,
            width: nSize, // 图片的宽高也不能少
            height: scale * size.height,
            custom:true,
          });
        });
      }
    }

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      setImage(e.target?.result as string);
      handleOk('image', e.target?.result as string);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    const {visible, type} = modal;
    setIsModalOpen(visible);
    return () => {
    };
  }, [modal]);

  useEffect(() => {
    if (!isModalOpen) {
      setlink("");
      setlinkLabel("");
    }
  }, [isModalOpen]);

  useEffect(() => {

    emitter.on("node_active", (data) => {
      const {mindMap, node} = data;
      // mindMap.nodeImgAdjust.resizeBtnSize = 32;
      if (node){
        setSelectedMindmap(mindMap);
        setSelectedNode(node);
        global.g_currentSelectMindmap = node;
      }

    });
    emitter.on("imagePreview", (data) => {
      setImagePreview(data);
    });

    emitter.on("mindmapAddImage",(data)=>{
      setTimeout(()=>{
        // dialogChooseImageRef.current?.onShowDialog();
        setIsShowDialogChooseCardPdf(true);
        setTimeout(()=>{
          dialogChooseCardPdfRef.current?.onShowDialog(elements,'image')
        },150)
      },300);
    })

    emitter.on('mindmapAddVideo',(data)=>{
      setTimeout(()=>{
        // dialogChooseImageRef.current?.onShowDialog();
        setIsShowDialogChooseCardPdf(true);
        setTimeout(()=>{
          dialogChooseCardPdfRef.current?.onShowDialog(elements,'video')
        },150)
      },300);
    })

    emitter.on('mindmapAddAudio',(data)=>{
      setTimeout(()=>{
        // dialogChooseImageRef.current?.onShowDialog();
        setIsShowDialogChooseCardPdf(true);
        setTimeout(()=>{
          dialogChooseCardPdfRef.current?.onShowDialog(elements,'audio')
        },150)
      },300);
    })

    emitter.on('mindmapAddFile',(data)=>{
      setTimeout(()=>{
        // dialogChooseImageRef.current?.onShowDialog();
        setIsShowDialogChooseCardPdf(true);
        setTimeout(()=>{
          dialogChooseCardPdfRef.current?.onShowDialog(elements,'file')
        },150)
      },300);
    })

    emitter.on('mindmapAddHighlight',(data)=>{
      setTimeout(()=>{
        // dialogChooseImageRef.current?.onShowDialog();
        setIsShowDialogChooseCardPdf(true);
        setTimeout(()=>{
          dialogChooseCardPdfRef.current?.onShowDialog(elements,'highlight')
        },150)
      },300);
    })

    emitter.on('mindmapCopylink',(data)=>{
      let szCopylink = createCopyLink('project',PROJECT_ID,'board',global.g_currentBoardId,'mindmap',global.g_currentSelectMindmap.mindMap.renderer.root.uid,true,null,global.g_currentSelectMindmap.uid);
      console.log(szCopylink);
    })

    /**
     * mindmap 添加链接...... add link 最后转到的地方
     */
    recvMessage(EVENT_MINDMAP_LINK_INFO,(msg,data)=>{
      setMindmapNodeLink(data);
    });

    recvMessage(EVENT_MINDMAP_ADD_PDF,(msg,data)=>{
      setIsShowDialogChooseCardPdf(true);
      setTimeout(()=>{
        dialogChooseCardPdfRef.current?.onShowDialog(elements,'pdf')
      },150)

    });

    recvMessage(EVENT_MINDMAP_ADD_CARD,(msg,data)=>{
      setIsShowDialogChooseCardPdf(true);
      setTimeout(()=>{
        dialogChooseCardPdfRef.current?.onShowDialog(elements,'card')
      },150)
    });

    recvMessage(EVENT_MINDMAP_DELETE_CARD,(msg,data)=>{

    });

    return () => {
      emitter.all.clear();

      unSubscribe(EVENT_MINDMAP_LINK_INFO);
      unSubscribe(EVENT_MINDMAP_ADD_PDF);
      unSubscribe(EVENT_MINDMAP_ADD_CARD);
      unSubscribe(EVENT_MINDMAP_DELETE_CARD)
    };
  }, []);

  /**
   * 设置链接
   * @param data
   */
  const setMindmapNodeLink = (data)=>{
    if (data.data.linkInfo.includes('childType=card')){
      global.g_currentSelectMindmap.setAttachment({
        url: data.data.linkInfo,
        title: imageLabel,
      });
    }else{
      global.g_currentSelectMindmap.setHyperlink(data.data.linkInfo,'');
    }


    const currentText = getTextFromHtml(global.g_currentSelectMindmap.getData().text);
    let text = currentText;
    if (currentText == '@' || isStringNullOrEmpty(currentText)) {
      text = `<p><span style="color: ${isDarkMode()?'rgb(204, 204, 204)':'rgb(86, 86, 86)'};font-family: OpenSans;font-size: 16px;">${data.data.library?.name}</span></p>`;
    } else {
      let str = global.g_currentSelectMindmap.getData().text;
      let newStr = str.replace(/@(?=[^@]*$)/, '');
      text = newStr;
    }
    if (!text){
      text = '';
    }

    global.g_currentSelectMindmap.setText(text);
    const newData = global.g_currentSelectMindmap.mindMap.getData();
    for (let i=0;i<5;i++){
      //只能这样更新。这个奇葩的东西...
      setTimeout(()=>{
        mutateElement(global.g_currentSelectMindmap.mindMap.element,{data:newData});
      },i*100)
    }

    const config = global.g_currentSelectMindmap?.mindMap?.element?.config;
    //读取默认的节点配置，改样式...
    if (config){
      global.g_currentSelectMindmap.setStyles({
        fontFamily: config.fontFamily,//"微软雅黑, Microsoft YaHei",
        fontSize: config.subnodeFontSize,
      });
    }
  }


  return (
      <div className="mind-map-wrapper" onMouseDown={(e) => e.stopPropagation()}>
        <AntdImage
            width={200}
            style={{display: "none"}}
            src=""
            preview={{
              destroyOnClose: true,
              visible: imagePreview.visible,
              src: imagePreview.href,
              onVisibleChange: (value) => {
                setImagePreview({visible: value, href: ""});
              },
            }}
        />

        <input
            style={{display:"none"}}
            onChange={handleFileChange}
            type="file"
            id="fileInput"
            accept="image/*"
        />

        {/*//选择图片*/}
        <DialogChooseImage ref={dialogChooseImageRef} onOkClicked={(obj:any)=>{
          if (obj.action == 'uploadImage') {
            document.getElementById('fileInput')?.click();
          }else if (obj.action == 'base64') {
            handleOk('image',obj.base64Image)
          }else if (obj.action == 'file') {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent<FileReader>) => {
              setImage(e.target?.result as string);
              handleOk('image', e.target?.result as string);
            };
            reader.readAsDataURL(obj.file);
          }
        }}/>

        {
          isShowDialogChooseCardPdf &&
          <DialogChooseCardPdf ref={dialogChooseCardPdfRef} onOkEvent={async (obj:any)=>{
            if (obj.type == 'pdf') {
              const szFileName = obj.fileName;
              let szImgBase64 = await getPdfImageThumb(getLocalFilePath(szFileName,obj.isAbsolutePath));
              //图片保存到本地
              const szLocalfileName = generateUUID2()+'.png';
              await ipcInvoke('write-base64-image',{imgBase64:szImgBase64,fileName:szLocalfileName})
              handleOk('image','localfile://'+szLocalfileName,obj)
            }else if (obj.type == 'card') {
              // let szImgBase64 = await noteToPng(appState,obj.showName,obj.content,obj.width,obj.height);
              // handleOk('image',szImgBase64,obj);


              // noteToPng(appState,obj.name,obj.doc,obj.width,obj.height).then(async (res)=>{
              //   const szLocalfileName = generateUUID2()+'.png';
              //   await ipcInvoke('write-base64-image',{imgBase64:res,fileName:szLocalfileName})
              //   handleOk('image','localfile://'+szLocalfileName,obj,"icon")
              // })

              handleOk('image','',obj,"icon");

              const card = await getCardById(obj.id);
              if (card){
                if ((Date.now() - card.createTime) < 2000){
                  //认为是新建的卡片....
                  window.showMessageTip(t('CardCreated1'),t('View'),'editCard',()=>{
                    window.showDialogCard(card);
                  });
                }
              }
            }else if (obj.type == 'image'){
              let szImgPath = getLocalFilePath(obj.fileName,obj.isAbsolutePath)
              setImage(szImgPath);
              handleOk('image', szImgPath);

              // window.showDialogMindmapLinkMode((szMode:any)=>{
              //   handleOk('image', "localfile://"+obj.fileName,null,szMode);
              // })
            }else if (obj.type == 'video' || obj.type == 'file' || obj.type == 'pdfAnno' || obj.type == 'videoAnno' || obj.type == 'audioAnno' || obj.type == 'cardAnno' || obj.type == 'audio'){
              let szDeeplink = createCopyLink("library",obj.id,obj.type,null,null,null,false);
              setMindmapNodeLink({data:{linkInfo:szDeeplink,library:obj}})
            }
            else{
              //随便什么文件了
              let szDeeplink = createCopyLink("library",obj.id,obj.type,null,null,null,false);
              setMindmapNodeLink({data:{linkInfo:szDeeplink,library:obj}})
            }
          }} onCloseEvent={()=>{
            setIsShowDialogChooseCardPdf(false);
          }}/>
        }



        {/*<Modal*/}
        {/*    title={modal.type}*/}
        {/*    open={isModalOpen}*/}
        {/*    onOk={handleOk}*/}
        {/*    onCancel={handleCancel}*/}
        {/*>*/}
        {/*  {modal.type === "link" ? (*/}
        {/*      <div className="item">*/}
        {/*        <span>链接</span>*/}
        {/*        <Input*/}
        {/*            placeholder=""*/}
        {/*            value={link}*/}
        {/*            onChange={(e) => {*/}
        {/*              setlink(e.target.value);*/}
        {/*            }}*/}
        {/*        />*/}

        {/*        <span>名称</span>*/}
        {/*        <Input*/}
        {/*            value={linkLabel}*/}
        {/*            placeholder=""*/}
        {/*            onChange={(e) => setlinkLabel(e.target.value)}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*  ) : (*/}
        {/*      <div className="item">*/}
        {/*        <span>导入</span>*/}
        {/*        <input*/}
        {/*            onChange={handleFileChange}*/}
        {/*            type="file"*/}
        {/*            id="fileInput"*/}
        {/*            accept="image/*"*/}
        {/*        />*/}
        {/*        <br/>*/}
        {/*        /!* <br />*/}
        {/*    <span>方式二：链接</span>*/}
        {/*    <Input*/}
        {/*      placeholder=""*/}
        {/*      onChange={(e) => {*/}
        {/*        setImage(e.target.value);*/}
        {/*      }}*/}
        {/*    /> *!/*/}

        {/*        <span>名称</span>*/}
        {/*        <Input*/}
        {/*            placeholder=""*/}
        {/*            value={imageLabel}*/}
        {/*            onChange={(e) => setImageLabel(e.target.value)}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*  )}*/}
        {/*</Modal>*/}
      </div>
  );
});

export default MindMap;
